import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ServicesSection.css';

const ServicesSection: React.FC = () => {
  const navigate = useNavigate();

  const handleCardClick = (path: string) => {
    navigate(path);
  };

  return (
    <section className="services-section" data-section="services">
      <div className="container">
        <div className="services-header">
          <h2>Unsere <span className="highlight-text">Leistungen</span></h2>
          <p>Wir gestalten betriebsnahe Technologiebildung - von der KI-Keynote bis hin zum Aufbau einer KI-Werkstatt.</p>
        </div>
        
        <div className="services-columns">
          <div className="services-column">
            <h3 className="column-heading">Technologie</h3>
            <div 
              className="service-card clickable"
              onClick={() => handleCardClick('/ki-werkstatt')}
              style={{ cursor: 'pointer' }}
            >
              <div className="service-image">
                <img 
                  src="/assets/images/leistungen/ki-werkstatt.png"
                  alt="KI-Werkstätten"
                  onError={(e) => {
                    console.error('Failed to load ki-werkstatt image:', e.currentTarget.src);
                    e.currentTarget.src = '/assets/images/common/course-placeholder.svg';
                  }}
                />
              </div>
              <div className="service-content">
                <h4>KI-Werkstätten</h4>
                <p>KI-Werkstätten machen KI regional und überregional erlebbar. Wir unterstützen beim Aufbau von mobilen und regionalen KI-Werkstätten durch die Bereitstellung von Hard- und Software, Beispielen realer KI-Projekte sowie das erforderliche Knowhow. Somit schaffen wir Orte, an denen die praktische Anwendung und Integration von KI in den Unternehmensalltag im Fokus stehen.</p>
              </div>
            </div>
          </div>

          <div className="services-column">
            <h3 className="column-heading">Bildung</h3>
            <div 
              className="service-card clickable"
              onClick={() => handleCardClick('/ki-kurse')}
              style={{ cursor: 'pointer' }}
            >
              <div className="service-image">
                <img 
                  src="/assets/images/leistungen/ki-kurse.jpeg"
                  alt="KI-Kurse"
                  onError={(e) => {
                    console.error('Failed to load KI-Kurse image:', e.currentTarget.src);
                    e.currentTarget.src = '/assets/images/common/course-placeholder.svg';
                  }}
                />
              </div>
              <div className="service-content">
                <h4>KI-Kurse</h4>
                <p>In unseren praxisorientierten KI-Kursen werfen Teilnehmer - vom Azubi bis zur Geschäftsführung - einen Blick unter die Motorhaube von KI. Unsere KI-Kurse zeichnen sich durch die Kombination aus Theorie und Praxis aus. Ziel ist es, fundiertes Wissen über KI zu vermitteln und Teilnehmer zu befähigen, KI-Potenziale im eigenen Betrieb zu identifizieren und zu beurteilen.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
